import styled from 'styled-components'

export const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fb;
  color: #0f172a;
  position: relative;
  padding: 24px;
`

export const HeaderSlot = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
`

export const ContentWrap = styled.div`
  text-align: center;
  margin: 0 auto;
  padding: 40px 0;
`

export const ActionsWrap = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
`

export const Container = styled.div`
  width: 100%;
`

export const Heading = styled.h1`
  color: #888;
`

export const LogoWrap = styled.div`
  width: 260px;
  max-width: 60vw;
  margin: 0 auto 12px;
  opacity: 0.95;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`
